import { render, staticRenderFns } from "./RightsResult.vue?vue&type=template&id=ed0b058c"
import script from "./RightsResult.vue?vue&type=script&lang=js"
export * from "./RightsResult.vue?vue&type=script&lang=js"
import style0 from "./RightsResult.vue?vue&type=style&index=0&id=ed0b058c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports